export interface IDashboardGoalsItem {
  forecastPercentage: number
  formattedActual: string
  formattedForecast: string
  formattedGoal: string
  pace: string
  percentage: number
}

export interface IDashboardGoalsResponse {
  title: string
  sales: IDashboardGoalsItem
  cars: IDashboardGoalsItem
}

export type GoalChartType = 'ring' | 'bar'
